import type { FunctionComponent } from 'react';
import { JsonView } from 'react-json-view-lite';

import { BusinessConfig, LenderConfig } from '@kanda-libs/ks-frontend-services';

import Profile from 'components/shared/Profile';

export interface CompanyFinanceDetailsProps {
  fca?: string;
  lenderConfigs?: LenderConfig[];
  businessConfig?: BusinessConfig;
}

const CompanyFinanceDetails: FunctionComponent<CompanyFinanceDetailsProps> =
  function ({ fca, lenderConfigs, businessConfig }) {
    if (!fca && !lenderConfigs) return null;
    return (
      <Profile.Section title="Finance Details" className="pb-4 mb-6 text-left">
        <>{fca ? <Profile.Property label="FCA number" value={fca} /> : null}</>
        <>
          {lenderConfigs ? <JsonView data={{ lenderConfigs }} /> : null}
          {businessConfig ? <JsonView data={{ businessConfig }} /> : null}
        </>
      </Profile.Section>
    );
  };

export default CompanyFinanceDetails;
